import { render, staticRenderFns } from "./IncomingOrdersExtraTags.vue?vue&type=template&id=31e0adcd&scoped=true"
import script from "./IncomingOrdersExtraTags.vue?vue&type=script&lang=js"
export * from "./IncomingOrdersExtraTags.vue?vue&type=script&lang=js"
import style0 from "./IncomingOrdersExtraTags.vue?vue&type=style&index=0&id=31e0adcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0adcd",
  null
  
)

export default component.exports